module.exports = __webpack_public_path__ + "static/media/thumb.dba612d1.jpg";